// extracted by mini-css-extract-plugin
export default {"center":"Spinner_center__lNiJA","spinner":"Spinner_spinner__L3aY5","spinner-aib1d7":"Spinner_spinner-aib1d7__n9kUl"};